import { createRouter, createWebHistory } from 'vue-router';
import db from "../helpers/db";
import store from "../store";
import auth from './auth';
import professional from './professional';
import { initWebSocket, disconnectWebSocket } from '../websocket';
import { isMarketplacePlace } from '../helpers/marketplacePlace';
import { usesSelfServiceBilling } from '../helpers/platformSubscription';

const routes = [
  ...auth,
  ...professional,
  {
    path: "/:pathMatch(.*)*",
    redirect: "/404",
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes
});

router.beforeEach((to, from, next) => {
  const hasValidToken = db.token != null && db.token !== 'null';
  const isAuthenticated = store.getters['auth/isAuth'] && hasValidToken;

  if (to.meta.auth && !isAuthenticated) {
    disconnectWebSocket();
    store.commit('auth/clearSession');

    if (to.path !== '/login' && to.path !== '/') {
      next({ path: '/login', query: { nextUrl: to.fullPath } });
      return;
    }
  }

  if (to.meta.auth && isAuthenticated && store.state.auth.mustSetupTwoFactor && to.path !== '/setup-two-factor') {
    next({ path: '/setup-two-factor' });
    return;
  }

  if (to.path === '/dashboard' && store.state.auth.place == null) {
    next({path: '/places'});
    return;
  }

  const marketplaceAllowedPaths = [
    '/places',
    '/subscription/ativar-gestao',
    '/login',
    '/register',
    '/reset-password',
    '/setup-two-factor',
    '/',
  ];
  const isMarketplaceAllowedRoute = marketplaceAllowedPaths.some(
    (p) => to.path === p || to.path.startsWith(p + '/'),
  );

  if (
    to.meta.auth
    && store.state.auth.place
    && isMarketplacePlace(store.state.auth.place)
    && !isMarketplaceAllowedRoute
  ) {
    next({ path: '/places', query: { marketplace_redirect: '1' } });
    return;
  }

  const subscriptionAllowedPaths = ['/subscription', '/subscription/plans', '/subscription/invoices', '/subscription/statement', '/subscription/overdue', '/subscription/payment-method', '/places', '/login', '/setup-two-factor', '/'];
  const isSubscriptionRoute = subscriptionAllowedPaths.some((p) => to.path === p || to.path.startsWith(p + '/'));

  const selfServiceSubscriptionPaths = [
    '/subscription/plans',
    '/subscription/invoices',
    '/subscription/statement',
    '/subscription/payment-method',
    '/subscription/overdue',
  ];
  const isSelfServiceSubscriptionRoute = selfServiceSubscriptionPaths.some(
    (p) => to.path === p || to.path.startsWith(p + '/'),
  );

  if (to.meta.auth && isSelfServiceSubscriptionRoute && !usesSelfServiceBilling()) {
    next({ path: '/subscription' });
    return;
  }

  if (to.meta.auth && store.state.auth.place?.platform_subscription_is_blocked && !isSubscriptionRoute) {
    next({ path: '/subscription/overdue' });
    return;
  }

  if (to.meta.auth && store.state.auth.platformSubscription?.is_blocked && !isSubscriptionRoute) {
    next({ path: '/subscription/overdue' });
    return;
  }

  if (to.meta.auth && isAuthenticated) {
    initWebSocket();
  }

  setTimeout(() => {
    window.scrollTo(0, 0);
    document.title = to.meta.title ?? 'Ubbimed';
  }, 100);

  next();
});

export default router
